import { useContext } from "react"
import ConsentContext from "cookiesConsent/features/getConsent/context"

const useConsent = () => useContext(ConsentContext)

export default useConsent
